export const toTtfbMetric = ({ value, attribution: { connectionDuration, dnsDuration, requestDuration, waitingDuration, cacheDuration, }, }) => {
    return {
        ttfb: Math.trunc(value),
        ttfbConnectionDuration: Math.trunc(connectionDuration),
        ttfbDnsDuration: Math.trunc(dnsDuration),
        ttfbRequestDuration: Math.trunc(requestDuration),
        ttfbWaitingDuration: Math.trunc(waitingDuration),
        ttfbCacheDuration: Math.trunc(cacheDuration),
    };
};
//# sourceMappingURL=ttfb.js.map